import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'

// ------------------------------------
// Constants
// ------------------------------------
export const SMART_CODE_SERVICE_DOWNLOAD = keyMirror({
  INIT_REQUEST: null,
  INIT_SUCCESS: null,
}, 'SMART_CODE_SERVICE_DOWNLOAD')

// ------------------------------------
// Actions
// ------------------------------------
export function init() {
  return (dispatch) => {
    dispatch(callAPI({
      dispatch: dispatch,
      endpoint: 'test.json',
      requestAction: SMART_CODE_SERVICE_DOWNLOAD.INIT_REQUEST,
      successAction: SMART_CODE_SERVICE_DOWNLOAD.INIT_SUCCESS,
      success: function(result) {}
    }))
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [SMART_CODE_SERVICE_DOWNLOAD.INIT_REQUEST]: (state, action) => Object.assign({}, state, action.payload),
  [SMART_CODE_SERVICE_DOWNLOAD.INIT_SUCCESS]: (state, action) => Object.assign({}, state, action.payload),
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'smartCodeServiceDownload',
    reducerMap: {
      smartCodeServiceDownloadState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
